import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
// import Avatare from "./landing/pages/Avatare"
// import Ecommerce from "./landing/pages/Ecommerce"
// import Playbook from "./landing/pages/PlayBookAI"
import Signup from "./screens/Auth/OrgSignup";

import Main from "./template/Main";
import AddEmoji from "./screens/Administration/AddEmoji";
import CloneAvatare from "./screens/Administration/CloneAvatare";
import Quickstart from "./screens/Library/Quickstart";
import Folders from "./screens/Library/DataFolders";
import Translation from "./screens/Library/Translation";
import ErrorPage from "./screens/ErrorPage";
import Home from "./screens/Home";
import TrainMyModel from "./screens/Classroom/TrainMyModel";
import TrainBySubject from "./screens/Classroom/TrainBySubject";
import TestMyAvatare from "./screens/Classroom/TestMyAvatare";
import Analytics from "./screens/Operations/Analytics";
import Integrations from "./screens/Operations/Integrations";
import WhisperAI from "./screens/Research/WhisperAI";
import DallE from "./screens/Research/DallE";
import ChatGPT from "./screens/Research/ChatGPT";
import Videos from "./screens/Library/Videos";
import AddMyEmoji from "./screens/Administration/AddMyEmoji";
import ScoreAndRating from "./screens/Classroom/ScoreAndRating";
import QuestionsAndAnswersScreen from "./screens/Library/QuestionsAndAnswers";
import AddNewQuestion from "./screens/Library/AddNewQuestion";
import SelectModel from "./screens/Classroom/SelectModel";
import SelectSubjectsToTrain from "./screens/Classroom/SelectSubjectsToTrain";
import SelectIntegration from "./screens/Operations/SelectIntegration";
import EditAvatare from "./screens/Administration/EditAvatare";
import Login from "./screens/Auth/OrgLogin";
import Organization from "./template/Organization";
import Profile from "./screens/Organization/Profile";
import Teams from "./screens/Organization/Teams";
import MemberLogin from "./screens/Auth/MemberLogin";
import MemberSignup from "./screens/Auth/MemberSignup";
import Landing from "./screens/Organization/Landing";
// import PublicRoute from './PublicRoute';
// import PrivateRoute from './PrivateRoute';
import LandingTwo from "./screens/Organization/LandingTwo";
import Payment from "./screens/Organization/Billing/Payment";
import Billing from "./screens/Organization/Billing/Billing";
import React, { useState } from "react";
import SuperAdmin from "./screens/Organization/SuperAdmin";
import Usage from "./screens/Organization/Usage";
import AvatarMonitoringAndControl from "./components/Operations/AnalyticsComponents/AvatarMonitoringAndControl";
import TrainigData from "./components/Operations/AnalyticsComponents/TrainingData";
import ActivityOverview from "./components/Operations/AnalyticsComponents/ActivityOverview";
import PolicyQuestions from "./components/Operations/AnalyticsComponents/PolicyQuestions";
import HistoryTable from "./screens/Organization/HistoryTable";
import Documentation from "./screens/Operations/Documentation";
import Help from "./components/common/Help";
import WhisperPlayground from "./components/Research/WhisperPlayground";
import Template from "./screens/Classroom/Template";
import TestMyAvatareNew from "./screens/Classroom/TestMyAvatareNew";
import { BotCustomization } from "./screens/BotCustomization/BotCustomization";
import { MyAvatar } from "./screens/Administration/MyAvatar";
import { CreateAvatareFromScratch } from "./screens/Administration/CreateAvatareFromScratch";
import TemplatesLibrary from "./screens/SequentialStartup/TemplateLibrary/TemplatesLibrary";
import TemplateHistory from "./screens/SequentialStartup/TemplatesHistory/TemplateHistory";
import DataFiles from "./screens/Library/DataFiles";
import NewFileUpload from "./components/Classroom/NewFileUpload/NewFileUpload";
import TrainingData from "./components/Operations/AnalyticsComponents/TrainingData";
import InitialAuth from "./components/Authorization/IniatialAuth/IniatialAuth";
import AuthElement from "./components/Authorization/IniatialAuth/AuthElement";
import Apps from "./components/common/Apps";
import { useSidebar } from "./components/common/SidebarContext";
import Settings from "./screens/Settings/settings";
import HistoryScreen from "./screens/Classroom/AvatareHistory";

function App() {
  const [credits, setCredits] = useState(20);
  const [totalCredits, setTotalCredits] = useState();
  const [value, setValue] = useState(20);
  const [isOrganizer, setIsOrgnizer] = useState();
  const superAdminEmail = localStorage.getItem("email");
  const [changeCredits, setChangeCredits] = useState(false);
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  const subdomain = parts[0];
    const {openApps,setOpenApps,profile,isSuperAdim}=useSidebar()
  
  /* eslint eqeqeq: 0 */
  /*jshint eqeqeq: false */

  return (
    <>
      {openApps && <Apps openApps={openApps} setOpenApps={setOpenApps} profile={profile} isSuperAdim={isSuperAdim}/>}
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Login and signup routes */}
            <Route exact path="/signup" element={<Signup />} />
            {/* <Route exact path="/Login/:id" element={<MemberLogin/>}/> */}
            <Route exact path="/Signup/:id" element={<MemberSignup />} />
            <Route
              exact
              path="/login"
              element={<Login setIsOrgnizer={setIsOrgnizer} />}
            />

            <Route exact path="/auth" element={<AuthElement />} />
            {/* <Route exact path="/avatare" element={<Landing />} /> */}
            {/* <Route exact path="/" element={<LandingTwo/>}/> */}
            {/* <Route exact path="/" element={<Avatare/>}/> */}
            {/* <Route exact path='/ecommerce' element={<Ecommerce/>}/> */}
            {/* <Route exact path='/playbook' element={<Playbook/>}/> */}
            <Route
              exact
              path="/"
              element={
                <InitialAuth>
                  <Main
                    setTotalCredits={setTotalCredits}
                    totalCredits={totalCredits}
                    changeCredits={changeCredits}
                  />
                </InitialAuth>
              }
            >
              {/* Default route and sequential startup*/}
              {subdomain === "sequential-startup" && (
                <>
                  <Route
                    path="/"
                    element={
                      <InitialAuth>
                        <Home />
                      </InitialAuth>
                    }
                  />
                  <Route
                    path="/sequential-startup/templates-libray"
                    element={
                      <InitialAuth>
                        <TemplatesLibrary />
                      </InitialAuth>
                    }
                  />
                  <Route
                    path="/sequential-startup/templates-history"
                    element={
                      <InitialAuth>
                        <TemplateHistory />
                      </InitialAuth>
                    }
                  />
                  <Route
                    path="/sequential-startup/test-template-avatare"
                    element={
                      <InitialAuth>
                        <TestMyAvatareNew />
                      </InitialAuth>
                    }
                  />
                  <Route
                    path="/sequential-startup/customize-bot"
                    element={
                      <InitialAuth>
                        <BotCustomization />
                      </InitialAuth>
                    }
                  />
                  <Route
                    path="/sequential-startup/template"
                    element={
                      <InitialAuth>
                        <Template />
                      </InitialAuth>
                    }
                  />
                </>
              )}
              {subdomain === "conversational" && (
                <Route
                  path="/"
                  element={
                    <InitialAuth>
                      <MyAvatar />
                    </InitialAuth>
                  }
                />
              )}

              {/* <Route path="/" element={<Main/>}/> */}
              <Route
                path="/admin/createAvatar"
                element={
                  <InitialAuth>
                    <CreateAvatareFromScratch />
                  </InitialAuth>
                }
              />

              <Route
                path="/admin/editAvatar"
                element={
                  <InitialAuth>
                    <EditAvatare />
                  </InitialAuth>
                }
              />
              {/* <Route path="/admin/createNewAvatar" element={ <CreateNewAvatare/> } /> */}

              <Route
                path="/admin/addEmoji"
                element={
                  <InitialAuth>
                    <AddEmoji />
                  </InitialAuth>
                }
              />
              <Route
                path="/admin/MyAvatare"
                element={
                  <InitialAuth>
                    <MyAvatar />
                  </InitialAuth>
                }
              />
               <Route
                path="/settings"
                element={
                  <InitialAuth>
                    <Settings />
                  </InitialAuth>
                }
              />

              <Route
                path="/admin/addMyEmoji"
                element={
                  <InitialAuth>
                    <AddMyEmoji />
                  </InitialAuth>
                }
              />
              <Route
                path="/admin/cloneAvatare"
                element={
                  <InitialAuth>
                    <CloneAvatare />
                  </InitialAuth>
                }
              />
              {/* Library routes */}
              <Route
                path="/library/quickstart"
                element={
                  <InitialAuth>
                    <Quickstart />
                  </InitialAuth>
                }
              />
              <Route
                path="/library/quickstart/videos"
                element={
                  <InitialAuth>
                    <Videos />
                  </InitialAuth>
                }
              />
              <Route
                path="/library/dataFiles"
                element={
                  <InitialAuth>
                    <Folders />
                  </InitialAuth>
                }
              />
              <Route
                path="/library/dataFiles/files/:id/:name"
                element={
                  <InitialAuth>
                    <DataFiles />
                  </InitialAuth>
                }
              />
              <Route
                path="/library/dataFiles/file-upload/:id"
                element={
                  <InitialAuth>
                    <NewFileUpload />
                  </InitialAuth>
                }
              />
              <Route
                path="/library/translation"
                element={
                  <InitialAuth>
                    <Translation />
                  </InitialAuth>
                }
              />
              {/* Classroom routes */}

              <Route
                path="/classroom/selectModel/:Id"
                element={
                  <InitialAuth>
                    <SelectModel />
                  </InitialAuth>
                }
              />
              <Route
                path="/classroom/trainMyModel"
                element={
                  <InitialAuth>
                    <TrainMyModel setChangeCredits={setChangeCredits} />
                  </InitialAuth>
                }
              />
              <Route
                path="/classroom/trainBySubject"
                element={
                  <InitialAuth>
                    <TrainBySubject />
                  </InitialAuth>
                }
              />

              <Route
                path="/classroom/testMyAvatare"
                element={
                  <InitialAuth>
                    <TestMyAvatare />
                  </InitialAuth>
                }
              />
              <Route
                path="/classroom/avatare-history"
                element={
                  <InitialAuth>
                    <HistoryScreen />
                  </InitialAuth>
                }
              />
              <Route
                path="/classroom/template"
                element={
                  <InitialAuth>
                    <Template />
                  </InitialAuth>
                }
              />
              <Route
                path="/classroom/scoreAndRating"
                element={
                  <InitialAuth>
                    <ScoreAndRating />
                  </InitialAuth>
                }
              />
              <Route
                path="/classroom/QuestionsAndAnswers"
                element={
                  <InitialAuth>
                    <QuestionsAndAnswersScreen />
                  </InitialAuth>
                }
              />
              <Route
                path="/classroom/addNewQuestion"
                element={
                  <InitialAuth>
                    <AddNewQuestion />
                  </InitialAuth>
                }
              />
              <Route
                path="/classroom/SelectSubjectsToTrain/:Id"
                element={
                  <InitialAuth>
                    <SelectSubjectsToTrain />
                  </InitialAuth>
                }
              />
              {/* Operations routes */}
              <Route
                path="/operations/analytics"
                element={
                  <InitialAuth>
                    <Analytics />
                  </InitialAuth>
                }
              />
              <Route
                path="/operations/monitoringandcontrol/"
                element={
                  <InitialAuth>
                    <AvatarMonitoringAndControl />
                  </InitialAuth>
                }
              />
              <Route
                path="/operations/trainigdata"
                element={
                  <InitialAuth>
                    <TrainingData />
                  </InitialAuth>
                }
              />
              <Route
                path="/operations/policyquestion"
                element={
                  <InitialAuth>
                    <PolicyQuestions />
                  </InitialAuth>
                }
              />
              <Route
                path="/operations/activityoverview"
                element={
                  <InitialAuth>
                    <ActivityOverview superAdminEmail={superAdminEmail} />
                  </InitialAuth>
                }
              />
              <Route
                path="/operations/integrations"
                element={
                  <InitialAuth>
                    <Integrations />
                  </InitialAuth>
                }
              />
              <Route
                path="/operations/selectIntegration/:id"
                element={
                  <InitialAuth>
                    <SelectIntegration />
                  </InitialAuth>
                }
              />
              <Route
                path="/operations/documentation"
                element={
                  <InitialAuth>
                    <Documentation />
                  </InitialAuth>
                }
              />

              {/* Research and development routes */}
              <Route
                path="/research/whisperAI"
                element={
                  <InitialAuth>
                    <WhisperAI />
                  </InitialAuth>
                }
              />
              <Route
                path="/research/dallE"
                element={
                  <InitialAuth>
                    <DallE />
                  </InitialAuth>
                }
              />
              <Route
                path="/research/chatGPT"
                element={
                  <InitialAuth>
                    <ChatGPT setChangeCredits={setChangeCredits} />
                  </InitialAuth>
                }
              />
              <Route
                path="/research/whisperplayground"
                element={
                  <InitialAuth>
                    <WhisperPlayground />
                  </InitialAuth>
                }
              />

              {/* Error routes */}
              <Route path="error" element={<ErrorPage />} />
              <Route
                path="/help"
                element={
                  <InitialAuth>
                    <Help />
                  </InitialAuth>
                }
              />
            </Route>
            <Route
              exact
              path="/organization"
              element={
                <InitialAuth>
                  <Organization />
                </InitialAuth>
              }
            >
              <Route
                path="workspace"
                element={
                  <InitialAuth>
                    <h1>Workspace</h1>
                  </InitialAuth>
                }
              />
              <Route
                path="profile"
                element={
                  <InitialAuth>
                    <Profile />
                  </InitialAuth>
                }
              />
              <Route
                path="team"
                element={
                  <InitialAuth>
                    <Teams />
                  </InitialAuth>
                }
              />
              <Route
                path="credithistory"
                element={
                  <InitialAuth>
                    <HistoryTable />
                  </InitialAuth>
                }
              />
              <Route
                path="superadmin"
                element={
                  superAdminEmail == "daren.jackson@avatare.com" ? (
                    <InitialAuth>
                      <SuperAdmin />
                    </InitialAuth>
                  ) : (
                    <ErrorPage />
                  )
                }
              />
              <Route
                path="usage"
                element={
                  <InitialAuth>
                    <Usage />
                  </InitialAuth>
                }
              />
              <Route
                path="payment"
                element={
                  <InitialAuth>
                    <Payment
                      value={value}
                      setValue={setValue}
                      setCredits={setCredits}
                      credits={credits}
                    />
                  </InitialAuth>
                }
              />
              <Route
                path="paymentintegration"
                element={
                  <InitialAuth>
                    <Payment
                      value={value}
                      setValue={setValue}
                      setCredits={setCredits}
                      credits={credits}
                    />
                  </InitialAuth>
                }
              />
              <Route
                path="billing"
                element={
                  <InitialAuth>
                    <Billing
                      value={value}
                      setValue={setValue}
                      setCredits={setCredits}
                      credits={credits}
                    />
                  </InitialAuth>
                }
              />
            </Route>
          </Routes>
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
